import angular from 'angular';
import { PatchInterceptor } from './PatchInterceptor';

angular
	.module('sh.patch', [])
	.factory('PatchInterceptor', PatchInterceptor)
	.config($httpProvider => {
		'ngInject';
		$httpProvider.interceptors.push('PatchInterceptor');
	});
